import observation from '@/store/observation/observation'
import helpersObservation from '@/store/observation/helpers'

export default {
    observation,
    helpersObservation,
}
